import { InfoWindow, useMap, useMapsLibrary } from "@vis.gl/react-google-maps";
import { useEffect, useMemo, useState } from "react";

//polyline code from documentation routes-api example:
//https://github.com/visgl/react-google-maps/blob/main/examples/routes-api/src/components/polyline.tsx

//you can use encoded paths google sends you or provide an array of {lat, lng}
//https://developers.google.com/maps/documentation/javascript/shapes
export const Polyline = (props) => {
  const {
    path,
    encodedPath,
    infoWindowMessage,
    closeInfoWindowNotif,
    ...polylineOptions
  } = props;
  const polylineOptionsMemoized = useMemo(() => {
    return polylineOptions;
  }, [props]);
  const map = useMap();
  const geometryLibrary = useMapsLibrary("geometry");
  const mapsLibrary = useMapsLibrary("maps");

  const [polyline, setPolyline] = useState();
  const [showInfoWindow, setShowInfoWindow] = useState(false);
  const [infoWindowCoord, setInfoWindowCoord] = useState();
  // console.log("close info window notif in polyline", closeInfoWindowNotif);
  // console.log("polyline show info window", infoWindowMessage, showInfoWindow);
  // create poyline once available
  useEffect(() => {
    if (showInfoWindow) {
      setShowInfoWindow(false);
    }
  }, [closeInfoWindowNotif]);
  useEffect(() => {
    if (!mapsLibrary) return;

    // console.log("maps library reran");
    setPolyline(new mapsLibrary.Polyline());
  }, [mapsLibrary]);

  // update options when changed
  useEffect(() => {
    if (!polyline) return;
    // console.log("polyline or polylineoptions reran");

    polyline.setOptions(polylineOptions);
  }, [polyline, polylineOptionsMemoized]);

  // decode and update polyline with encodedPath
  //   console.log("polyline path", path);
  useEffect(() => {
    if ((!encodedPath && !path) || !geometryLibrary || !polyline) return;
    // console.log("polyline, encodedpath, geometry library re-ran");

    if (encodedPath) {
      polyline.setPath(geometryLibrary.encoding.decodePath(encodedPath));
    } else if (path) {
      polyline.setPath(path);
    }
  }, [polyline, encodedPath, geometryLibrary]);

  function handleMouseClick(e) {
    // console.log("map event", e.latLng.lat());
    // console.log("polyline click event", e);
    setShowInfoWindow(true);
    setInfoWindowCoord({
      lat: e.latLng.lat(),
      lng: e.latLng.lng(),
    });
  }
  // add polyline to map
  useEffect(() => {
    if (!map || !polyline) return;

    // console.log("adding polyline to map");
    polyline.setMap(map);
    // let clickListener = //set the add listenrs to variables so we can remove them later
    polyline.addListener("click", handleMouseClick);
    // let hoverListener =
    // polyline.addListener("mousemove", handleMouseClick);
    // console.log("this is the map", map);

    return () => {
      polyline.setMap(null);
      //   map.removeListener(clickListener); //doesn't work must be called on google.map.event normally but idk how to do it using this library. //This mayyy cause a memory leak/ram usage to go up indefinitely over time but not sure.
      polyline.unbindAll(); //I think this will help clear memory on unmount? Not sure.
    };
  }, [map, polyline]);

  return (
    <>
      {showInfoWindow && infoWindowMessage && (
        <InfoWindow
          position={infoWindowCoord}
          headerContent={infoWindowMessage}
          onClose={() => {
            setShowInfoWindow(false);
          }}
        />
      )}
    </>
  );
};
